// Lazy loading implementation using Intersection Observer API
class LazyImageLoader {
  constructor() {
    this.imageObserver = null;
    this.init();
  }

  init() {
    if ('IntersectionObserver' in window) {
      this.imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const image = entry.target;
            this.loadImage(image);
            observer.unobserve(image);
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.01
      });

      this.observeImages();
    } else {
      // Fallback for browsers without IntersectionObserver
      this.loadAllImages();
    }
  }

  observeImages() {
    // Handle images with data-src (existing implementation)
    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(image => {
      this.imageObserver.observe(image);
    });

    // Handle regular img tags with 'lazy' class and convert them
    const regularLazyImages = document.querySelectorAll('img.lazy[src]:not([data-src]):not(.lazy-converted)');
    regularLazyImages.forEach(image => {
      // Convert to lazy loading format
      image.dataset.src = image.src;
      image.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';
      image.classList.add('lazy-image', 'lazy-converted');
      
      // Handle srcset if present
      if (image.srcset) {
        image.dataset.srcset = image.srcset;
        image.srcset = '';
      }
      
      this.imageObserver.observe(image);
    });
  }

  loadImage(image) {
    if (image.dataset.src) {
      image.src = image.dataset.src;
      image.removeAttribute('data-src');
      image.classList.add('loaded');
      
      // Handle srcset if present
      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        image.removeAttribute('data-srcset');
      }
    }
  }

  loadAllImages() {
    // Load images with data-src (existing implementation)
    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(image => this.loadImage(image));

    // Handle regular img tags with 'lazy' class for fallback
    const regularLazyImages = document.querySelectorAll('img.lazy[src]:not([data-src]):not(.lazy-converted)');
    regularLazyImages.forEach(image => {
      // Convert and load immediately for fallback
      image.dataset.src = image.src;
      image.classList.add('lazy-image', 'lazy-converted');
      this.loadImage(image);
    });
  }

  // Method to reinitialize after dynamic content is added
  refresh() {
    if (this.imageObserver) {
      this.observeImages();
    }
  }
}

// Initialize lazy loading when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.lazyImageLoader = new LazyImageLoader();
});

// Export for use in other modules
export default LazyImageLoader;